import { Text } from '@user-portal/wikr-components';
import React from 'react';

import { IAdditionalStatusInfo } from '../../types';

import * as S from '../styled';

const AdditionalStatusInfo = ({ captions, mb }: IAdditionalStatusInfo) => {
    return (
        <S.AdditionalStatusInfo $mb={mb}>
            {captions?.title && <Text mb={8}>{captions.title}</Text>}
            <Text color="text-secondary">{captions?.description}</Text>
        </S.AdditionalStatusInfo>
    );
};

export default AdditionalStatusInfo;
